import loader from '../moduleLoader.js';
import animateScrollTo from 'animated-scroll-to';

class ScrollScreen {
    constructor(button) {
        this.button = button;
        this.hideButton = this.hideButton.bind(this);
        this.scroll = this.scroll.bind(this);
    }
    init() {
        if(document.body.classList.contains('home') == false) {
            return;
        }
        this.button.classList.remove('hidden');
        this.button.addEventListener('click', this.scroll);
        window.addEventListener('scroll', () => {
            var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
            if(scrollTop > 10) {
                this.hideButton();
            }
            else {
                this.button.classList.remove('sections__scrolltocontent--hidden');                
            }
        });
    }
    hideButton() {
        this.button.classList.add('sections__scrolltocontent--hidden');
    }
    scroll(e) {
        this.hideButton();
        var element = document.querySelector('.sections').children[1];
        animateScrollTo(element, {speed: 900});
    }
}

loader.add('ScrollScreen', ScrollScreen);

export default ScrollScreen;